module.exports = __webpack_public_path__ + "media/styles/images/svg/trash-gray-5a2261434b70c93c981224a8cb770fa1.svg";